// VideoControls.tsx

import { FiPause, FiPlay, FiRefreshCcw } from "react-icons/fi";
import { MdPauseCircleOutline, MdPlayCircleOutline } from "react-icons/md";
import Button from "../../../components/core/form-components/Button";

interface VideoControlsProps {
  isPlaying: boolean;
  onPlayPause: () => void;
  onReset: () => void;
  onExport: () => void;
}

export const VideoControls = ({
  isPlaying,
  onPlayPause,
  onReset,
  onExport,
}: VideoControlsProps) => {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-1">
        <Button onClick={onPlayPause} onlyIcon>
          {isPlaying ? <FiPause size={24} /> : <FiPlay size={24} />}
        </Button>

        <Button onClick={onReset} onlyIcon>
          <FiRefreshCcw size={22} />
        </Button>
      </div>
      <Button onClick={onExport} primary className="md:!py-3 md:!px-8">
        Save{" "}
      </Button>
    </div>
  );
};
